{
  "CONFIG_EDITOR": {
    "CREATE_CONFIG": "Create account template",
    "ERROR": {
      "ACCOUNT_GROUP_REQUIRED": "Account is required",
      "NAME_REQUIRED": "Name is required",
      "NAME_EXISTS": "An account template with this name already exists",
      "NO_MATCHING_ACCOUNT_GROUPS_FOUND": "No matching accounts found"
    },
    "APPLY_TO_ACCOUNTS": "Apply to account",
    "NAME": "Name",
    "SOURCE_ACCOUNT_GROUP": "Source account",
    "TEMPLATE_NAME_PLACEHOLDER": "Enter template name",
    "LOADING": "Looking for features that can be saved as part of this template",
    "NO_OBJECTS": {
      "TITLE": "No available templates",
      "DESCRIPTION": "This source account has no templates. Choose a different source account to continue."
    }
  },
  "COMMON": {
    "SAVE": "Save",
    "SAVE_AND_CONTINUE": "Save and continue",
    "NEXT": "Next",
    "BACK": "Back",
    "EDIT": "Edit",
    "CANCEL": "Cancel",
    "CREATE": "Create",
    "APPLY": "Apply",
    "CLOSE": "Close",
    "YES": "Yes",
    "NO": "No"
  },
  "CONFIG_MANAGER": {
    "CREATE_CONFIG": "Create template",
    "CONFIGURATIONS": "Account templates"
  },
  "CONFIG_LIST": {
    "NAME": "Name",
    "SOURCE": "Source account",
    "CONTAINS": "Contains",
    "DATE_CREATED": "Date created",
    "ACTIONS": "Actions",
    "EMPTY_STATE": "No templates found",
    "EMPTY_STATE_ACTION": "Create a template from one account, to apply to others"
  },
  "CONFIG_DETAILS": {
    "NAME": "Name",
    "SOURCE": "Source",
    "CONTAINS": "Contains",
    "LOAD_ERROR": "Error loading template",
    "LOAD_STATUS_ERROR": "Error loading template statuses",
    "ACCOUNT_GROUP_ERROR": "Error loading account group data",
    "APPLIED_STATUSES_TITLE": "Applied template statuses",
    "STATUS_SUCCESSFUL": "Successful",
    "STATUS_FAILED": "Failed",
    "STATUS_PENDING": "Pending",
    "UNKNOWN": "Unknown",
    "NAMESPACE_COLUMN": "Applied to",
    "STATUS_COLUMN": "Status",
    "NO_STATUSES": "No statuses found",
    "APPLIED_DATE_COLUMN": "Applied date",
    "ACTIONS_COLUMN": "Actions",
    "DOWNLOAD_ERROR_FILE": "Download error file",
    "FILE_EXPIRED_TITLE": "File not available",
    "FILE_EXPIRED": "This file is no longer available for download. Error files are automatically deleted after {{days}} days for your security.",
    "MODAL_OK": "OK"
  },
  "CONFIG_CARD": {
    "APPLY_TO": "Apply to",
    "SOURCE": "Source",
    "CONTAINS": "Contains",
    "DELETE": "Delete",
    "DELETE_SUCCESS": "Template deleted successfully",
    "DELETE_ERROR": "Failed to delete template"
  },
  "CONFIG_APPLIER": {
    "TITLE": "Apply account template",
    "TARGET_TYPE": "Type",
    "TARGET_TYPE_PLACEHOLDER": "Type",
    "TARGET_NAME": "Name",
    "TARGET_NAME_PLACEHOLDER": "Search for a name",
    "CONTAINER_TYPE": {
      "ACCOUNT_GROUP": "Account",
      "MULTI_LOCATION_GROUP": "Multi location group"
    },
    "SERVICE_ACCOUNT_SELECTOR_LABEL": "Select service account",
    "SERVICE_ACCOUNT_SELECTOR_BADGE": "SuperAdmin only",
    "SERVICE_ACCOUNT_SELECTOR_PLACEHOLDER": "Search for a name",
    "CONFIG_SELECTOR_LABEL": "Select account template",
    "CONFIG_OPTIONS_LABEL": "Select features of {{configName}} to apply",
    "CONFIG_OPTIONS_INFO": "Applying this template will only add or update capabilities, tools, and assistants. Nothing currently assigned will be removed.",
    "SUBMISSION_SUCCESS": "Application process started",
    "SUBMISSION_ERROR": "Error applying account template",
    "NO_ACCOUNTS_ALERT": "Selected companies have no associated accounts",
    "TARGET_SELECTOR_LABEL": "Select target account",
    "CONFIG_COMPONENTS": "Account template components"
  },
  "CONFIG_DELETE": {
    "TITLE": "Delete template",
    "MESSAGE": "Are you sure you want to delete the following items:"
  },
  "WARNING": {
    "EXTERNAL_DEPENDENCY": {
      "AUTOMATION_PARAMETER": "automation has an external dependency for a parameter in a task definition",
      "AUTOMATION_PARAMETER_VALUE_ERROR": "automation has an external dependency for a parameter in a task definition, but the value could not be extracted",
      "EXTENSION_FIELD_REQUIRED": "Extension field required",
      "CUSTOM_FIELD_REQUIRED": "Custom field required",
      "AI_TOOL_REQUIRED": "AI tool required"
    },
    "STATIC_LIST": {
      "INITIALIZATION": "This list is static. It will be initialized using the criteria, but the values may differ from the source list."
    },
    "SUCCESS": "Account template created successfully",
    "ERROR": "Failed to create template"
  }
}
